/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ObservableEllipse.ts
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 1045
 * ---
 * Description:
 */

import { ObservableShape } from './ObservableShape';
import Pamela              from '@revodigital/pamela';
import { Editor }          from './Editor';
import { makeObservable }  from 'mobx';

export class ObservableEllipse extends ObservableShape<Pamela.Ellipse> {
  constructor(shape: Pamela.Ellipse, editor: Editor) {
    super(shape, editor);
    makeObservable(this);
  }
}